export default __webpack_public_path__ + "static/media/845.e4ff3abf.gif";